export default "__VITE_ASSET__9cdbbcd2__"